// Module
var code = "<div id=tertiary-nav><div ng-repeat=\"link in links\"><a ng-click=changeState(link.name) ng-class=\"{active: currentState === link.name}\"><p ng-if=\"link.name === 'Account'\">{{link.name}} <span>(NEW)</span></p><p ng-if=\"link.name !== 'Account'\">{{link.name}}</p></a></div></div>";
// Exports
module.exports = code;